import { v3 } from "oc-threejs/short3";
import * as Doms from "oc-ui/Doms";
import * as _ from "lodash";
import React from "react";
import { CoordinateSystem } from "./CoordinateSystem";

/**
 * Ein effizientes, logarithmisches & unendliches Millimeterpapier
 */
export function Raster({ cs }: { cs: CoordinateSystem }) {
  const unitInPixel = cs.lengthToScreen(cs.zoomUnitInM);

  const strokeColor = Doms.getCssVar("--color-grundriss-raster");
  const strokeWidth = (x) => (x === 0 ? "1.5" : x === 5 ? "0.5" : "0.2");

  const origin = cs.pointToScreen(v3());

  const svgString = `
    <svg xmlns="http://www.w3.org/2000/svg"
         viewBox="0 0 ${unitInPixel} ${unitInPixel}"
         fill="transparent"
         stroke="${strokeColor}">
        ${_.range(0, unitInPixel, unitInPixel / 10)
          .map(
            (x, index) => `
          <line x1="${x}" y1="${0}" x2="${x}" y2="${unitInPixel}" stroke-width="${strokeWidth(
            index
          )}" />
          <line y1="${x}" x1="${0}" y2="${x}" x2="${unitInPixel}" stroke-width="${strokeWidth(
            index
          )}" />
          `
          )
          .join("")}
    </svg>`;

  const encodedSvg = btoa(svgString);
  const backgroundImage = `url('data:image/svg+xml;base64,${encodedSvg}')`;

  return (
    <div
      className="raster grid-fullscreen no-pointer-events-tree"
      style={{
        backgroundImage: backgroundImage,
        backgroundSize: `${unitInPixel}px ${unitInPixel}px`,
        backgroundPosition: `${origin.x}px ${origin.y}px`,
      }}
    ></div>
  );
}
